// extracted by mini-css-extract-plugin
module.exports = {"dot":"styles_dot__xcxnf","load":"styles_load__8OFh7"};